/* Crown Ness — carte cadeau : 5 montants + « Autre montant » (saisie libre, par pas de 5 €).
   Les montants 10 à 500 € existent comme variantes du produit ; seuls 50 / 100 / 150 / 200 / 250 € sont affichés
   en boutons (voir crown-giftcard.css), la saisie sélectionne la variante correspondante.
   Version de la feuille de style : 3 (la feuille est chargée avec l'empreinte de ce fichier : toute modification
   du CSS demande de modifier ce numéro, sinon l'ancienne version reste en cache). */
(function () {
  if (window.__cnGiftCard) return;
  window.__cnGiftCard = true;

  /* Charge la feuille de style voisine (même dossier d'assets que ce script) */
  var self = document.currentScript;
  if (self && self.src) {
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = self.src.replace(/crown-giftcard\.js/, 'crown-giftcard.css');
    document.head.appendChild(css);
  }

  var HANDLE = 'carte-cadeau-crown-ness';
  var PRESETS = [50, 100, 150, 200, 250];
  var MIN = 10;
  var MAX = 500;
  var STEP = 5;
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = en
    ? { other: 'Other amount', placeholder: 'Enter an amount', ok: 'Confirm', err: 'Enter an amount between 10 € and 500 €, in multiples of 5 €.' }
    : { other: 'Autre montant', placeholder: 'Saisir un montant', ok: 'Valider', err: 'Saisissez un montant entre 10 € et 500 €, par multiples de 5 €.' };

  var state = { open: false, value: '' };

  function amountOf(input) {
    return parseInt(input.value, 10);
  }

  function picker() {
    return document.querySelector('variant-picker[data-product-handle="' + HANDLE + '"]');
  }

  function checkedAmount(vp) {
    var c = vp.querySelector('input[type="radio"]:checked');
    return c ? amountOf(c) : 0;
  }

  function select(vp, n) {
    var inputs = vp.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (amountOf(inputs[i]) === n) {
        inputs[i].click();
        return true;
      }
    }
    return false;
  }

  /* Le thème n'actualise le prix affiché qu'au premier choix : on aligne le prix sur le montant choisi */
  function syncPrice() {
    var vp = picker();
    var n = vp ? checkedAmount(vp) : 0;
    if (!n) return;
    var txt = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(n);
    var els = document.querySelectorAll('product-price[data-product-id="' + vp.getAttribute('data-product-id') + '"] .price');
    for (var i = 0; i < els.length; i++) {
      if (els[i].closest('product-card')) continue;
      if (els[i].textContent.trim() !== txt) els[i].textContent = txt;
    }
  }

  function render() {
    syncPrice();
    var vp = picker();
    if (!vp || !vp.parentNode) return;
    var box = vp.parentNode.querySelector('.cn-gc-custom');
    if (!box) {
      box = document.createElement('div');
      box.className = 'cn-gc-custom';
      box.innerHTML =
        '<button type="button" class="cn-gc-other">' + T.other + '</button>' +
        '<form class="cn-gc-form" hidden novalidate>' +
        '<input class="cn-gc-input" type="number" inputmode="numeric" min="' + MIN + '" max="' + MAX + '" step="' + STEP + '" placeholder="' + T.placeholder + '" aria-label="' + T.other + '">' +
        '<button type="submit" class="cn-gc-ok">' + T.ok + '</button>' +
        '<p class="cn-gc-error" role="alert" hidden>' + T.err + '</p>' +
        '</form>';
      vp.insertAdjacentElement('afterend', box);
    }
    var current = checkedAmount(vp);
    var isCustom = current > 0 && PRESETS.indexOf(current) === -1;
    var btn = box.querySelector('.cn-gc-other');
    var form = box.querySelector('.cn-gc-form');
    var input = box.querySelector('.cn-gc-input');
    if (isCustom && !state.open) state.open = true;
    btn.classList.toggle('is-active', state.open || isCustom);
    form.hidden = !state.open;
    if (isCustom && document.activeElement !== input) input.value = current;
    else if (!isCustom && state.value && document.activeElement !== input) input.value = state.value;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cn-gc-other');
    if (!btn) return;
    state.open = !state.open;
    render();
    var input = document.querySelector('.cn-gc-input');
    if (state.open && input) input.focus();
  });

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cn-gc-input')) state.value = e.target.value;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('cn-gc-form')) return;
    e.preventDefault();
    var vp = picker();
    var err = form.querySelector('.cn-gc-error');
    var n = parseInt(form.querySelector('.cn-gc-input').value, 10);
    var ok = vp && n >= MIN && n <= MAX && n % STEP === 0 && select(vp, n);
    err.hidden = !!ok;
  });

  /* Choisir un des boutons de montant referme la saisie */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest && t.closest('variant-picker[data-product-handle="' + HANDLE + '"]')) {
      if (PRESETS.indexOf(amountOf(t)) !== -1) {
        state.open = false;
        state.value = '';
      }
      setTimeout(render, 0);
      setTimeout(render, 500);
      setTimeout(render, 1500);
    }
  });

  /* Horizon remplace le sélecteur de variante après chaque choix : on réaffiche l'interface */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      render();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
